import { IChild } from "../../../../share/types/case/children";
import { IAbductor } from "../../../../share/types/case/abductor";
import { CasesService } from "../../../../share/services/cases";
export interface IUploadImageSettings {
    caseId: string;
    personIndex: number;
    personId: string;
    providers: any;
    imageId: number;
    base64: string;
    uploadType: 'Child' | 'Abductor';
    retry: number;
}

export class UploadPersonImages {
    constructor(public setValue, public newCase, public getState) {

    }
    public async uploadImages() {
        this.setValue({ loadingMessage: 'Uploading and Procesing Photos', caseSaved: true })
        return Promise.all([this.uploadPersonImages("children"), this.uploadPersonImages("abductors")]);
    }

    public uploadPersonImages(type: "children" | "abductors") {
        const { providers, agencyCode, caseId } = this.newCase;
        const persons: Array<IChild | IAbductor> = this.newCase[type];
        const isChildren = type === "children";
        const idProperty = isChildren ? "childId" : "abductorId";
        const uploadType = isChildren ? 'Child' : 'Abductor'
        let promises: any[] = [];
        persons.forEach((person, personIndex) => {
            const { images } = person;
            const personId = person[idProperty]
            if (images && images.length > 0) {
                promises = images.map((base64, imageId) => this.uploadPersonImage({
                    caseId: `${agencyCode}-${caseId}`, personIndex, personId, providers,
                    imageId, base64, uploadType, retry: 0
                }));
            }
        });
        return Promise.all(promises);
    }

    public uploadPersonImage(settings: IUploadImageSettings) {
        const { caseId, personId, imageId, providers, uploadType, base64 } = settings
        const currentArray = settings.uploadType === 'Child' ? 'children' : 'abductors';
        const imageKey = `${currentArray},${settings.personIndex},${settings.imageId}`
        return this.ifWasNotUpload(imageKey, () => {
            return Promise.resolve()
                .then(() => this.setImageState(imageKey, "UPLOADING"))
                .then(() => CasesService.uploadImage({ caseId, id: personId, imageId, providers, type: uploadType, image: base64 }))
                .then((success) => this.manageResponse(success, settings, imageKey))
        })
    }    
    private manageResponse(success: boolean, settings: IUploadImageSettings, imageKey: string) {
        if (success) {
            return this.setImageState(imageKey, "SUCCESS")
        } else {
            settings.retry++;
            return settings.retry > 2 ?
                this.setImageState(imageKey, "FAILED") :
                new Promise(resolve => setTimeout(() => resolve(this.uploadPersonImage(settings)), 500))
        }
    }
    public getErrorsUploadingImage() {
        const ius = this.getState().imageUploadingStatus;
        return Object.keys(ius).filter((key) => ius[key].status === "FAILED")
    }
    public wasErrorsUploadingImages() {
        return this.getErrorsUploadingImage().length > 0
    }
    public setImageState(id, imageState: 'UPLOADING' | 'SUCCESS' | 'FAILED') {
        return this.ifWasNotUpload(id, () => this.setValue(`imageUploadingStatus[${id}]`, { status: imageState }))
    }
    public ifWasNotUpload(id, fn: () => Promise<any>) {
        return new Promise((resolve) => this.wasImageUploaded(id) ? resolve() : resolve(fn()))
    }
    public wasImageUploaded(id: string) {
        const [type, index, imageId] = id.split(',');
        const status = this.getState().imageUploadingStatus;
        const image = this.getState().caseInfo[type][index].images[imageId];
        return status && status[id] && status[id].status === 'SUCCESS' || image.includes('https') || image === "";
    }
}


// WEBPACK FOOTER //
// ./src/modules/Case/Add/helpers/uploadImages.ts